module.exports = __webpack_public_path__ + "static/media/sobre-parceiros.0ae89c45.jpeg";